import $ from 'jquery';
import events from './events';
import miniCart from './minicart';
import '../../../validation/unobtrusive';

const orderForm = {
    _checkForAccountNameErrors: function ($form) {
        var $hiddenRecipientField = $form.find('[name="AccountName"]'),
            $textInput,
            $select,
            errorClass = 'input-validation-error';

        if (!$hiddenRecipientField.length) {
            return;
        }

        $textInput = $form.find('#txtAddHorseName');
        $select = $form.find('#ddlRecipientList select');

        if ($hiddenRecipientField.hasClass(errorClass)) {
            $textInput.addClass(errorClass);
            $select.addClass(errorClass);
        } else {
            $textInput.removeClass(errorClass);
            $select.removeClass(errorClass);
        }
    },
    _clearValidationSummary: function ($form) {
        var $container = $form.find('[data-valmsg-summary="true"]'),
            $list = $container.find('ul');

        if ($list && $list.length) {
            $list.empty();
            $container.addClass('validation-summary-valid').removeClass('validation-summary-errors');
        }
    },
    _showError: function (addItemReponse, title) {
        smartPak.ui.modal($('<strong class="alertTxt">' + addItemReponse.View + '</strong>').get(0), {
            title: title,
            removeContents: true,
            resizable: false
        });
    },
    _removeProductIdValidation: function ($form) {
        $form.find('#ProductId').removeAttr('data-val').removeAttr('data-val-required').removeAttr('data-val-number');
    },
    _submit: function ($form) {
        return $.post($form.attr('action'), $form.serialize());
    },
    _showDuplicateWarning: function (html) {
        if (!html) {
            html =
                "<p>Your best friend is already getting this product in your existing orders.</p><p>Please choose a different recipient, or review your <a href=\"/AutoShipManager\">AutoShip Manager</a>.</p>";
        }

        smartPak.ui.modal($('<div>' + html + '</div>').get(0), {
            title: 'Alert – duplicate product',
            removeContents: true,
            resizable: false
        });
    },
    _redirectToCart: function () {
        smartPak.page.redirectToUrl('/cart');
    },
    _shouldHideETA: function () {
        return /hawaii|alaska/gi.test(this.viewModel?.userDetectedLocation()?.state);
    },
    _handleTesProductResponse: function (html) {
        miniCart.show(html, this._shouldHideETA());
    },
    _handleResponse: function (response) {
        switch (response.NextAction) {
            case response.NextActionOptions.REDIRECT_TO_BUILDER:
            case response.NextActionOptions.REDIRECT_TO_CART:
            case response.NextActionOptions.REDIRECT_PC_ORDER:
                smartPak.page.redirectToUrl(response.RedirectUrl);
                break;
            case response.NextActionOptions.SHOW_MINI_CART:
                this._handleTesProductResponse(response.View);
                smartPak.customerInfo.refreshCartItemCount();
                break;
            case response.NextActionOptions.SHOW_SUCCESS:
                smartPak.customerInfo.refreshCartItemCount();
                break;
            case response.NextActionOptions.DUPLICATE_SUPPLEMENT_WARNING:
                this._showDuplicateWarning(response.View);
                break;
            case response.NextActionOptions.CUSTOMIZATION_MISSING:
                this._customizeNotificationRequired();
                break;
            case response.NextActionOptions.CUSTOMIZATION_BAD_CHARACTERS:
                this._showError(response, 'Customization Error');
                break;
            case response.NextActionOptions.TOO_MANY_ITEMS_IN_CART_WARNING:
                this._showError(response, 'Your cart is full');
                break;
            case response.NextActionOptions.UNEXPECTED_ERROR:
                this._showError(response, 'Error');
                break;
            default:
                break;
        }
    },
    _customizeNotificationRequired: function () {
        $('#divCustomizationMessage').addClass('notificationRequired');
    },
    _parseDynamicFormElements: function ($form) {
        $form
            .removeData('validator') /* added by the raw jquery.validate plugin */
            .removeData('unobtrusiveValidation'); /* added by the jquery unobtrusive plugin*/

        $.validator.setDefaults({
            ignore: []
        });
        $.validator.unobtrusive.parse($form);
    },
    setSubmitHandler: function ($form, onSubmit, viewModel) {
        if (!$form.length || !onSubmit) {
            return;
        }

        $form.on(
            'submit',
            function (e) {
                e.preventDefault();
                $('.otsWarning').addClass('jsHide');

                if (
                    /supplement|portionpak/.test(viewModel.type()) ||
                    (viewModel.isSPEUser() && viewModel.type() === 'tes')
                ) {
                    this._checkForAccountNameErrors($form);
                }

                if (viewModel && viewModel.hasCustomization && viewModel.customizationIsRequired) {
                    var customizationData = $('[name="CustomizationDataString"]').val();

                    $('#lnkCustomize').removeClass('requiredAlert');

                    if (customizationData === '') {
                        $('#lnkCustomize').addClass('requiredAlert');
                    }
                }
            }.bind(this)
        );

        requestAnimationFrame(
            function () {
                $form.data('validator').settings.submitHandler = function () {
                    this._clearValidationSummary($form);
                    this._parseDynamicFormElements($form);

                    if ($form.valid()) {
                        onSubmit($form);
                    }
                }.bind(this);
            }.bind(this)
        );
    },
    _shouldFireAddToCartEvent: function (response) {
        return (
            response &&
            response.NextAction &&
            response.NextAction !== response.NextActionOptions.DUPLICATE_SUPPLEMENT_WARNING &&
            response.NextAction !== response.NextActionOptions.UNEXPECTED_ERROR
        );
    },
    _fireAddToCartEvent: function (viewModel) {
        const FLY_STOPPERS_ITEM_NUMBER = 27055;
        const { id: productClassId, selectedProduct, childReportingCategory, parentReportingCategory, itemNumber, manufacturer: brand, name, isAutoShip: flyStopperIsATS, isPrivateLabel } = ko.toJS(viewModel);
        const { isAutoShip, id, isSmartPak, quantity, price } = selectedProduct;

        events.addCartItem({
            childReportingCategory,
            parentReportingCategory,
            brand: brand || 'unknown',
            name,
            isPrivateLabel,
            isAutoShip: itemNumber === FLY_STOPPERS_ITEM_NUMBER ? flyStopperIsATS : isAutoShip,
            isSmartPak: typeof isSmartPak === 'boolean' ? isSmartPak : false,
            itemNumber,
            productClassId,
            id,
            quantity,
            price: parseFloat(price.current.replace('$', ''))
        });
    },
    _preventCheckboxDeselectOnInput: function ($form) {
        $form.on('click', '.checkbox input[type=tel]', function (e) {
            e.preventDefault();
        });
    },
    init: function ($forms, viewModel) {
        if (!$forms.length) {
            return;
        }

        this.viewModel = viewModel;

        $forms.each(
            function (index, form) {
                var $form = $(form);

                if (viewModel.hasAttributes) {
                    this._removeProductIdValidation($form);
                }

                this._preventCheckboxDeselectOnInput($form);

                this._parseDynamicFormElements($form);
                this.setSubmitHandler(
                    $form,
                    function () {
                        var $button = $form.find('input[type=submit]');

                        $button.prop('disabled', true);

                        this._submit($form).done(
                            function (response) {
                                this._handleResponse(response, $form);

                                if (this._shouldFireAddToCartEvent(response)) {
                                    this._fireAddToCartEvent(viewModel);
                                }

                                $button.prop('disabled', false);
                            }.bind(this)
                        );
                    }.bind(this),
                    this.viewModel
                );
            }.bind(this)
        );
    }
};

export default orderForm;
